import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

import cardImg from "../assets/images/studyCardImg.png";
import FastIcon from "./FastIcon";
import { useNavigate } from "react-router-dom";
import useFavoriteCourse from "../hooks/useFavoriteCourse";
import { useEffect, useState } from "react";

const CardCourse = ({ info, isHome }: any) => {
  const navigate = useNavigate();
  const [favorite, setFavorite] = useState(info.is_favorite);
  const courseClicked = () => {
    navigate(`/course/${info.id}`);
  };
  useEffect(() => {
    if (localStorage.getItem("token")) setFavorite(info.is_favorite);
  }, [info]);

  const useFavorite = (id: string, isDelete: boolean = false) => {
    useFavoriteCourse(id, isDelete).then(() => {
      setFavorite(!isDelete);
    });
  };

  return (
    <Card
      className={"card-course-wrapper"}
      sx={{ boxShadow: "none", borderRadius: "8px" }}>
      <FastIcon
        name={favorite ? "containLike" : "like"}
        width={20}
        height={20}
        className={"like-icon"}
        onClick={useFavorite.bind(null, info.id, favorite)}
      />
      <CardMedia
        sx={{
          height: 162,
          "@media (max-width:1000px)": isHome
            ? {}
            : {
                width: "30%",
                height: "100%",
                borderRadius: 0,
              },
        }}
        image={cardImg}
        title="картинка курса"
      />

      <CardContent
        sx={{ cursor: "pointer" }}
        className={"card-content"}
        onClick={() => courseClicked()}>
        <Box className={"card-course-title"}>{info.name}</Box>
        <Typography variant="body2" color="text.secondary">
          {info.fullname_teacher}
        </Typography>
        <Box className={"card-course-price"}>
          {info.price === 0 ? "Бесплатно" : `${info.price} ₸`}
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardCourse;
